import React, { useState, useEffect, useReducer, useRef } from "react";
import SelectBox from "devextreme-react/select-box";
import rpsReducer from "../../reducers/rps";
import ScrollView from "devextreme-react/scroll-view";
import * as action from "../../actions/rps";
import DateBox from "devextreme-react/date-box";
import { TextBox } from "devextreme-react";
import "../../styles/sps.css";
import Button from "devextreme-react/button";
import { TagBox } from "devextreme-react/tag-box";
import moment from "moment";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import { alert } from "devextreme/ui/dialog";
import NEXUS_CONST from "../../common/constants";
import { postUserLog } from "../../actions/common";
const initialStates = {
  approvers: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: null,
  ophFile: null,
  rpsGridData: null,
};
const TargetState = (props) => {
  const [DoWhat, setDoWhat] = useState("");
  const [ToWhat, setToWhat] = useState("");
  const [HowMuch, setHowMuch] = useState("");

  const [byWhen, setByWhen] = useState(new Date());
  const [byWhenstatement, setbyWhenstatement] = useState(
    byWhen.toString().slice(0, 10)
  );
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  let { rpsAllData } = state;

  const [DueDate, setDueDate] = useState("");
  const [enableByWhen, setEnableByWhen] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    // getProblemSovingDatabyId
    action.fetchProblemSovingDatabyId(dispatch, props.rpsID);
    AsyncCallHandler(
      NEXUS_CONST.FETCH_PS_DATA + props.rpsID,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setByWhen(res?.data?.dueDate);
        setDoWhat(res?.data?.tsdoWhat);
        setToWhat(res?.data?.tstoWhat);
        setHowMuch(res?.data?.tshowMuch);
        let newDate = byWhen.toString().slice(0, 10);
        setbyWhenstatement(newDate);
        setIsDisabled(res?.data?.status === "Complete");
      }
    });
  }, []);

  const onSetHowMuch = (e) => {
    setHowMuch(e.value);
    setEnableByWhen(false);
  };

  const onByWhenDateChange = (e) => {
    setByWhen(e.value);
    onDueDateChange(e);
    setbyWhenstatement(e.value.toString().slice(0, 10));
  };
  const onDueDateChange = (e) => {
    setDueDate(e.value);
  };

  const saveSps = () => {
    if (DoWhat == null) {
      alert("Please enter Do What", "Alert");
    } else if (ToWhat == null) {
      alert("Please enter To What", "Alert");
    } else if (HowMuch == null) {
      alert("Please enter How Much", "Alert");
    } else if (byWhen == null) {
      alert("Please enter by When", "Alert");
    } else {
      let formData = {
        rpsid: props.rpsID,
        tsdoWhat: DoWhat,
        tstoWhat: ToWhat,
        tshowMuch: HowMuch,
        tsbyWhen: byWhen,
        dueDate: byWhen,
        lastSavedTab: "3",
      };

      AsyncCallHandler(
        NEXUS_CONST.MANAGE_PS_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (res) {
          props.setisOpen("3");
        }
      });
      props.handleSPSSave();
      //props.setisOpen("3");
      postUserLog({
        event: "Box 3 - Target State",
        data: {
          action: `PS-${props.rpsID} Saved`,
          module: "Digital Tier",
          section: props.navigationOn,
          siteUId: props.siteId,
          widget: "Structured Problem Solving",
          tierId: props.tierId,
        },
      });
    }
  };

  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 3 - &nbsp;</span>Target State
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveSps}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div className="dx-field">
          {/* <div className="rps-flex-container "> */}
          <TextBox
            name="DoWhat"
            label="Do What*"
            placeholder="Always refer to countermeasure the problem identified"
            // disabled={enableTargetState}
            onValueChanged={(e) => setDoWhat(e.value)}
            value={DoWhat}
          ></TextBox>
          <TextBox
            name="ToWhat"
            label="To What*"
            placeholder="Always refer to improve the KPI hurting"
            // disabled={enableTargetState}
            onValueChanged={(e) => setToWhat(e.value)}
            value={ToWhat}
          ></TextBox>
          <TextBox
            name="HowMuch"
            label="How Much *"
            // disabled={enableTargetState}
            placeholder="Don’t shoot for the entire gap. Maybe only a fraction of the gap can be closed. Set SMART Goal"
            onValueChanged={onSetHowMuch}
            value={HowMuch}
          ></TextBox>
          <DateBox
            label="By When*"
            labelMode="floating"
            // disabled={enableByWhen}
            onValueChanged={onByWhenDateChange}
            value={byWhen}
            type="date"
          ></DateBox>
          <h4 className="target-statement">{`Target Statement : ${
            DoWhat === null || "" ? "DOWhat" : DoWhat
          } on ${ToWhat === null || "" ? "ToWhat" : ToWhat} by ${
            HowMuch === null || "" ? "HowMuch" : HowMuch
          }, by ${byWhen === null || "" ? "ByWhen" : byWhenstatement}`}</h4>
        </div>
      </ScrollView>
    </>
  );
};

export default TargetState;
